module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z3-f825930b71b0f5f570904802b37a8d6d.svg";